import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Header from '../Header';

import {
  getRadioAudience,
  getRadioAudienceRecent
} from '../../../utils/apiMiniWidget';
import RadioAudience from '../../views/RadioAudience/RadioAudience';
import { Audiencias } from '../../../../assets/images/index';
import { StyledBoxInside, StyledTitleWidget, StyledWrapper } from './style';
import { SearchByDate } from '../../views/SearchByDate';

const defaultTextForNow = 'No existen datos para el día seleccionado.';

class RadioAudiencePage extends Component {
  constructor(props) {
    super(props);
    this.state = { recent: undefined, now: undefined };
    this.dateSelected = undefined;
  }

  componentDidMount() {
    getRadioAudience(moment().format('YYYY-MM-DD'))
      .then(radioNowData => {
        this.setState({ now: radioNowData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
    getRadioAudienceRecent()
      .then(radioResumeData => {
        this.setState({ recent: radioResumeData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  }

  selectDate = fromDate => () => {
    this.dateSelected = fromDate;
    getRadioAudience(fromDate)
      .then(radioNowData => {
        this.setState({ now: radioNowData });
      })
      .catch(error => {
        console.error('Error desde RadioAudience', error);
      });
  };

  clickTitle = () => {
    this.forceUpdate();
    this.componentDidMount();
  };

  render() {
    const { history } = this.props;
    const { recent, now } = this.state;

    moment.locale('es');
    return (
      <div
        className="pressResume_container"
        style={{ backgroundColor: '#FFF' }}
      >
        <Header history={history} />

        <StyledBoxInside>
          <StyledTitleWidget
            title="Audiencias de Radio"
            type="audiencesradio"
            icon={Audiencias}
            small
            onClick={this.clickTitle}
          />
          <StyledWrapper>
            <SearchByDate
              day={moment().format('DD')}
              month={moment().format('MMMM')}
              weekday={moment().format('dddd')}
              onClick={this.selectDate}
            />
          </StyledWrapper>
          <StyledWrapper>
            <RadioAudience
              key="1"
              dataList={now}
              defaultTextForNow={defaultTextForNow}
              title={`Audiencias de Radio del ${moment(
                this.dateSelected
              ).format('DD-MM-YYYY')}`}
            />
          </StyledWrapper>
          <StyledWrapper>
            {recent && recent.length > 0 && (
              <RadioAudience
                key="2"
                dataList={recent}
                title="Los más recientes"
              />
            )}
          </StyledWrapper>
        </StyledBoxInside>
      </div>
    );
  }
}

RadioAudiencePage.propTypes = {
  author: PropTypes.shape({
    user: PropTypes.shape({ name: PropTypes.string }),
    association: PropTypes.shape({ name: PropTypes.string })
  })
};

export default RadioAudiencePage;
